module.exports = __webpack_public_path__ + "img/zwx.d2d84b7f.png";